import { normalData } from 'utils/normal-data';
import instance from './axios';
import NotiDataService from './NotiDataService';
import { pingServer } from 'components/shared-components/Notification/GeneralNotification';
import { NOTI_SERVICE_URL } from '../configs/AppConfig';

const MODEL = 'notifications';

class NotificationService extends NotiDataService {
    constructor() {
        super(MODEL);
    }

    getNoti = async (page = 1, size = 10) => {
        try {
            let notiRoute = 'notifications/socket';
            const response = await instance.get(`${NOTI_SERVICE_URL}${notiRoute}?page=${page}&size=${size}`);

            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
        } catch (error) {
            return error;
        }
    };

    maskAsRead = async (id = '') => {
        try {
            let notiRoute = `notifications/maskAsRead/socket/${id}`;
            const response = await instance.put(`${NOTI_SERVICE_URL}${notiRoute}`);

            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
        } catch (error) {
            return error;
        }
    };

    massDelete = async (ids = []) => {
        try {
            let notiRoute = `notifications/socket`;
            const response = await instance.delete(`${NOTI_SERVICE_URL}${notiRoute}`,
                {
                    headers: {
                        'Content-Type': `application/json`,
                    },
                    data: { ids: ids }
                }
            );

            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
        } catch (error) {
            return error;
        }
    };
}

const notificationService = new NotificationService();

export default notificationService;